import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Badge from 'shopper/components/Badge';

import { sendEvent } from 'lib/gtag';
import { toBlogCategoryLink } from 'lib/links';

const ArticleBadge = ({ gaEventCategory, categoryName, categorySlug }) => {
  const onClick = () => {
    sendEvent({ action: 'tag_filter', category: gaEventCategory });
  };

  return (
    <NextLink href={toBlogCategoryLink(categorySlug)} prefetch={false} passHref>
      <a className="mb-6 size-fit">
        <Badge className="cursor-pointer" type="info" onClick={onClick}>
          {categoryName}
        </Badge>
      </a>
    </NextLink>
  );
};

ArticleBadge.propTypes = {
  categoryName: PropTypes.string.isRequired,
  categorySlug: PropTypes.string.isRequired,
  gaEventCategory: PropTypes.string.isRequired,
};

export default ArticleBadge;
